import { PropsWithChildren, useEffect } from 'react';
import usePageVisibility from '../../../hooks/usePageVisibility';
import useDidUpdateEffect from 'new/hooks/useDidUpdateEffect';

type PageVisibilityProps = {
  onVisibilityChange?: (visible: boolean) => void;
};

export default function PageVisibility(props: PropsWithChildren<PageVisibilityProps>) {
  const visible = usePageVisibility();
  useDidUpdateEffect(() => {
    if (typeof props.onVisibilityChange === 'function') {
      props.onVisibilityChange(visible);
    }
  }, [visible]);

  useEffect(() => {
    if (props.children) {
      throw new Error("This component can't have children.");
    }
  });

  return null;
}
